import { getString } from "../common/common";

export const SELECT_SEAT = "SELECT_SEAT";
export const SELECT_PADP = "SELECT_PADP";
export const SELECT_BOARDING_POINT = "SELECT_BOARDING_POINT";
export const SELECT_DROPPING_POINT = "SELECT_DROPPING_POINT";
export const SELECTED = "SELECTED";
export const BOOKED = "BOOKED";
export const AVAILABLE = "AVAILABLE";
export const FEMALE = "FEMALE";
export const GRAND_TOTAL = "GRAND_TOTAL";
export const SHOW_DETAILS = "SHOW_DETAILS";
export const HIDE_DETAILS = "HIDE_DETAILS";
export const TOTAL_FARE_DETAILS = "TOTAL_FARE_DETAILS";
export const PROVIDE_PASSENGER_DETAILS = "PROVIDE_PASSENGER_DETAILS";
export const CLOSE_CUSTOMER_DETAILS = "CLOSE_CUSTOMER_DETAILS";

export const SELECT_PDTC = "SELECT_PDTC";
export const SELECT = "SELECT";
export const SEATS = "SEATS";
export const BOARDING = "BOARDING";
export const DROPPING_POINT = "DROPPING_POINT";
export const UPPER = "UPPER";
export const LOWER = "LOWER";
export const SEATER = "SEATER";
export const SLEEPER = "SLEEPER";
export const BERTH = "BERTH";

export const translations = {
  en: {
    [SELECT_SEAT]: "Select Seat",
    [SELECT_PADP]: "Select Pickup and Dropoff point",
    [SELECT_BOARDING_POINT]: "Select Boarding Point",
    [SELECT_DROPPING_POINT]: "Select Dropping Point",
    [SELECTED]: "Selected",
    [BOOKED]: "Booked",
    [AVAILABLE]: "Available",
    [FEMALE]: "Female",
    [GRAND_TOTAL]: "Grand Total",
    [SHOW_DETAILS]: "Show Details",
    [HIDE_DETAILS]: "Hide Details",
    [TOTAL_FARE_DETAILS]: "Total Fare Details",
    [PROVIDE_PASSENGER_DETAILS]: "Provide Passenger Details",
    [CLOSE_CUSTOMER_DETAILS]: "CLOSE CUSTOMER DETAILS",
    [SELECT_PDTC]:
      "Please select seat(s), pick up & drop off location to continue",
    [SELECT]: "SELECT",
    [SEATS]: "SEATS",
    [BOARDING]: "BOARDING",
    [DROPPING_POINT]: "DROPPING POINT",
    [UPPER]: "Upper",
    [LOWER]: "Lower",
    [SEATER]: "Seater",
    [SLEEPER]: "Sleeper",
    [BERTH]:"Berth",
  },
  kn: {
    [SELECT_SEAT]: "ಸೀಟ್ ಅನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    [SELECT_PADP]: " ಪಿಕಪ್ ಮತ್ತು ಡ್ರಾಪ್‌ಆಫ್ ಪಾಯಿಂಟ್ ಆಯ್ಕೆಮಾಡಿ",
    [SELECT_BOARDING_POINT]: "ಹತ್ತುವ ಸ್ಥಳಗಳನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",
    [SELECT_DROPPING_POINT]: "ಇಳಿಯುವ ಸ್ಥಳಗಳನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",
    [SELECTED]: "ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ",
    [BOOKED]: "ಬುಕ್ ಮಾಡಲಾಗಿದೆ",
    [AVAILABLE]: "ಲಭ್ಯತೆ",
    [FEMALE]: "ಹೆಣ್ಣು",
    [GRAND_TOTAL]: "ಒಟ್ಟು ಮೊತ್ತ",
    [SHOW_DETAILS]: "ವಿವರಗಳನ್ನು ತೋರಿಸಿ",
    [HIDE_DETAILS]: "ವಿವರಗಳನ್ನು ಮರೆಮಾಡಿ",
    [TOTAL_FARE_DETAILS]: "ಒಟ್ಟು ದರದ ವಿವರಗಳು",
    [PROVIDE_PASSENGER_DETAILS]: "ಪ್ರಯಾಣಿಕರ ವಿವರಗಳನ್ನು ನೀಡಿ",
    [CLOSE_CUSTOMER_DETAILS]: "ಗ್ರಾಹಕರ ವಿವರಗಳನ್ನು ಮುಚ್ಚಿ",
    [SELECT_PDTC]:
      "ದಯವಿಟ್ಟು ಸೀಟ್(ಗಳನ್ನು) ಆಯ್ಕೆಮಾಡಿ, ಮುಂದುವರಿಸಲು ಸ್ಥಳವನ್ನು ಆರಿಸಿ ಮತ್ತು ಬಿಡಿ",
    [SELECT]: "ಆಯ್ಕೆ ಮಾಡಿ",
    [SEATS]: "ಸೀಟ್ ಗಳು ",
    [BOARDING]: "ಬೋರ್ಡಿಂಗ್",
    [DROPPING_POINT]: "ಡ್ರಾಪಿಂಗ್ ಪಾಯಿಂಟ್",
    [UPPER]: "ಮೇಲಿನ", 
    [LOWER]: "ಕೆಳಗಿನ ", //lower meaning in kannada is ಕಡಿಮೆ that means less but we need ಕೆಳಗೆ which is lower
    [SEATER]: "ಆಸನಗಳು",
    [SLEEPER]: "ಸ್ಲೀಪರ್",
    [BERTH]:"ಬರ್ತ್",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
